import { Result, Typography } from "antd";
import { useLocation } from "react-router-dom";

/**
 * Placeholder for the screens still to come. The sidebar already lists every
 * entry the user's roles allow, so clicking one has to land somewhere sensible
 * rather than on a blank page.
 */
export function NotMigratedPage() {
  const { pathname } = useLocation();

  return (
    <Result
      status="info"
      title="Noch nicht migriert"
      subTitle={
        <>
          Für <Typography.Text code>{pathname}</Typography.Text> gibt es noch keine React-Ansicht.
        </>
      }
    />
  );
}
